<template>
  <div>
    <!-- Dosya Yükleme Alanı -->
    <div class="mb-3">
      <label for="formFileMultiple" class="form-label">Dosya Seç</label>
      <input
          ref="fileInput"
          class="form-control"
          type="file"
          id="formFileMultiple"
          multiple
          @change="handleFileChange"
      />
    </div>

    <div class="mb-3">
      <label for="descriptionInput" class="form-label">Dosya Türü</label>
      <input
          type="text"
          id="descriptionInput"
          class="form-control"
          v-model="description"
          aria-label="Dosya Türü"
          placeholder="Dosya Türü..."
      />
    </div>

    <div class="button-group">
      <button class="btn btn-success" :disabled="isUploading" @click="saveFiles">
        {{ isUploading ? "Yükleniyor..." : "Kaydet" }}
      </button>
      <button class="btn btn-danger" @click="cancelUpload">İptal</button>
    </div>

    <!-- Listeleme Alanı -->
    <div>
      <h5 class="mt-4">Yüklenen Dosyalar</h5>
      <ul class="list-group" v-if="documents.length">
        <li
            v-for="doc in documents"
            :key="doc.id"
            class="list-group-item d-flex justify-content-between align-items-center"
        >
          <div>
            <strong>{{ doc.description }}</strong>
          </div>
          <div>
            <button class="btn btn-sm btn-info me-2" @click="downloadDocument(doc.id)">İndir</button>
            <button class="btn btn-sm btn-danger" @click="deleteDocument(doc.id)">Sil</button>
          </div>

        </li>
      </ul>
      <p v-else>Henüz yüklenmiş bir dosya bulunmamaktadır.</p>
    </div>
  </div>
</template>

<script>
import apiClient from "@/axios";

export default {
  name: "ContractFileUpload",
  props: ["contractId"],
  data() {
    return {
      files: [],
      description: "",
      documents: [],
      isUploading: false,
    };
  },
  mounted() {
    this.fetchDocuments();
  },
  methods: {
    handleFileChange(event) {
      this.files = event.target.files;
    },
    saveFiles() {
      if (this.files.length === 0 || this.description.trim() === "") {
        alert("Lütfen dosya ve açıklama giriniz.");
        return;
      }

      const formData = new FormData();
      Array.from(this.files).forEach((file) => {
        formData.append("file", file);
      });
      formData.append("description", this.description);
      formData.append("contractId", this.contractId);

      const token = localStorage.getItem("jwtToken");
      if (!token) {
        alert("Kullanıcı oturumu açık değil.");
        return;
      }

      this.isUploading = true;

      apiClient
          .post("/contract-document/upload", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${token}`,
            },
          })
          .then(() => {
            this.resetForm();
            this.fetchDocuments();
          })
          .catch((error) => {
            alert("Dosya yüklenirken bir hata oluştu.");
            console.error(error);
          })
          .finally(() => {
            this.isUploading = false;
          });
    },
    cancelUpload() {
      this.resetForm();
    },
    resetForm() {
      this.files = [];
      this.description = "";
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = "";
      }
    },
    fetchDocuments() {
      const token = localStorage.getItem("jwtToken");
      if (!token) return;

      apiClient
          .get("/contract-document/all", {
            headers: { Authorization: `Bearer ${token}` },
          })
          .then((response) => {
            this.documents = response.data.filter(
                (doc) => doc.contractId === this.contractId
            );
          })
          .catch((error) => {
            console.error("Belgeler alınırken hata oluştu:", error);
          });
    },
    deleteDocument(id) {
      const token = localStorage.getItem("jwtToken");
      if (!token) return;

      if (!confirm("Bu belgeyi silmek istediğinize emin misiniz?")) return;

      apiClient
          .delete(`/contract-document/${id}`, {
            headers: { Authorization: `Bearer ${token}` },
          })
          .then(() => {
            this.documents = this.documents.filter((doc) => doc.id !== id);
          })
          .catch((error) => {
            console.error("Silme sırasında hata oluştu:", error);
          });
    },
    downloadDocument(id) {
      const token = localStorage.getItem("jwtToken");
      if (!token) return;

      // Önce dosya bilgilerini al
      apiClient
          .get(`/contract-document/${id}`, {
            headers: {
              Authorization: `Bearer ${token}`
            }
          })
          .then((response) => {
            if (!response.data?.path) {
              alert("Dosya yolu alınamadı.");
              return;
            }

            // Dosyayı indir
            apiClient
                .get(`/contract-document/download/${id}`, {
                  headers: {
                    Authorization: `Bearer ${token}`
                  },
                  responseType: 'blob' // Dosyayı blob olarak al
                })
                .then((downloadResponse) => {
                  // Dosya adını al veya varsayılan bir ad kullan
                  const originalFileName = response.data.path.split('/').pop();

                  // Blob URL oluştur
                  const url = window.URL.createObjectURL(new Blob([downloadResponse.data]));

                  // İndirme linki oluştur
                  const link = document.createElement('a');
                  link.href = url;
                  link.setAttribute('download', originalFileName);

                  // İndirmeyi başlat
                  document.body.appendChild(link);
                  link.click();

                  // Temizlik
                  document.body.removeChild(link);
                  window.URL.revokeObjectURL(url);
                })
                .catch((error) => {
                  alert("Dosya indirilirken bir hata oluştu.");
                  console.error(error);
                });
          })
          .catch((error) => {
            alert("Dosya bilgileri alınırken bir hata oluştu.");
            console.error(error);
          });
    },

  },
};
</script>

<style scoped>
.button-group {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
</style>
